import React from 'react';
import { 
	func,
} from 'prop-types';


export default class Container extends React.Component {
	static propTypes = {
		render:func
	}
    
	constructor(props){
		super(props);
		this.state = {
			showMenu : false
		};
	}
    
	render(){
		const {render,...other} = this.props;
		return render({
		},other);
	}
}